/**
 * Base storage class. By default it simply wraps local storage.
 */
export class StorageBase {
  /**
   * Get storage property with key.
   */
  getItem(key: string): string {
    return window.localStorage.getItem(key);
  }

  /**
   * Set storage property with key.
   */
  setItem(key: string, value: string) {
    window.localStorage.setItem(key, value);
  }

  /**
   * Remove storage property with key.
   */
  removeItem(key: string) {
    window.localStorage.removeItem(key);
  }

  /**
   * Clear storage.
   */
  clear() {
    window.localStorage.clear();
  }
}
